import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import {
  getSubscriptionTiers,
  createSubscriptionTier,
  updateSubscriptionTier,
  deleteSubscriptionTier,
  getTierFeatures,
  updateTierFeatures,
  getTierPricing,
  updateTierPricing,
  getCheckoutCountries,
  createCheckoutCountry,
  updateCheckoutCountry,
  deleteCheckoutCountry,
  updateCountryCurrencies,
  getTermsVersions,
  createTermsVersion,
  updateTermsVersion,
  publishTermsVersion,
  deleteTermsVersion,
  getTermsVersion,
  duplicateTermsVersion,
  setActiveTab,
  setSelectedTier,
  clearMessages
} from '../../redux/actions/subscriptionManagementActions'

import SubscriptionManagement from '../../components/subscription-management'

class SubscriptionManagementPage extends Component {
  componentWillMount() {
    this.props.getSubscriptionTiers()
    this.props.getCheckoutCountries()
    this.props.getTermsVersions()
  }

  render() {
    return (
      <SubscriptionManagement
        tiers={this.props.tiers}
        tierFeatures={this.props.tierFeatures}
        tierPricing={this.props.tierPricing}
        countries={this.props.countries}
        selectedTierId={this.props.selectedTierId}
        activeTab={this.props.activeTab}
        loading={this.props.loading}
        saving={this.props.saving}
        error={this.props.error}
        errorMessage={this.props.errorMessage}
        successMessage={this.props.successMessage}
        deviceCategories={this.props.deviceCategories}
        supportedCurrencies={this.props.supportedCurrencies}
        featureDefinitions={this.props.featureDefinitions}
        onCreateTier={this.props.createSubscriptionTier}
        onUpdateTier={this.props.updateSubscriptionTier}
        onDeleteTier={this.props.deleteSubscriptionTier}
        onGetTierFeatures={this.props.getTierFeatures}
        onUpdateTierFeatures={this.props.updateTierFeatures}
        onGetTierPricing={this.props.getTierPricing}
        onUpdateTierPricing={this.props.updateTierPricing}
        onCreateCountry={this.props.createCheckoutCountry}
        onUpdateCountry={this.props.updateCheckoutCountry}
        onDeleteCountry={this.props.deleteCheckoutCountry}
        onUpdateCurrencies={this.props.updateCountryCurrencies}
        termsVersions={this.props.termsVersions}
        onGetTermsVersions={this.props.getTermsVersions}
        onCreateTermsVersion={this.props.createTermsVersion}
        onUpdateTermsVersion={this.props.updateTermsVersion}
        onPublishTermsVersion={this.props.publishTermsVersion}
        onDeleteTermsVersion={this.props.deleteTermsVersion}
        onGetTermsVersion={this.props.getTermsVersion}
        onDuplicateTermsVersion={this.props.duplicateTermsVersion}
        onTabChange={this.props.setActiveTab}
        onSelectTier={this.props.setSelectedTier}
        onClearMessages={this.props.clearMessages}
        translate={this.props.translate}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  tiers: state.subscriptionManagementReducer.tiers,
  tierFeatures: state.subscriptionManagementReducer.tierFeatures,
  tierPricing: state.subscriptionManagementReducer.tierPricing,
  countries: state.subscriptionManagementReducer.countries,
  termsVersions: state.subscriptionManagementReducer.termsVersions,
  selectedTierId: state.subscriptionManagementReducer.selectedTierId,
  activeTab: state.subscriptionManagementReducer.activeTab,
  loading: state.subscriptionManagementReducer.loading,
  saving: state.subscriptionManagementReducer.saving,
  error: state.subscriptionManagementReducer.error,
  errorMessage: state.subscriptionManagementReducer.errorMessage,
  successMessage: state.subscriptionManagementReducer.successMessage,
  deviceCategories: state.appSettingReducer.deviceCategories,
  supportedCurrencies: state.appSettingReducer.supportedCurrencies,
  featureDefinitions: state.appSettingReducer.featureDefinitions
})

const mapDispatchToProps = {
  getSubscriptionTiers,
  createSubscriptionTier,
  updateSubscriptionTier,
  deleteSubscriptionTier,
  getTierFeatures,
  updateTierFeatures,
  getTierPricing,
  updateTierPricing,
  getCheckoutCountries,
  createCheckoutCountry,
  updateCheckoutCountry,
  deleteCheckoutCountry,
  updateCountryCurrencies,
  getTermsVersions,
  createTermsVersion,
  updateTermsVersion,
  publishTermsVersion,
  deleteTermsVersion,
  getTermsVersion,
  duplicateTermsVersion,
  setActiveTab,
  setSelectedTier,
  clearMessages
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(SubscriptionManagementPage)
